var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFindAProvider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6400",
    d: "M13.756 7.317h-2.588V4.752H7.19v2.565H4.6v3.992H7.19v2.566h3.978v-2.566h2.588V7.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.756 16.963l4.41 4.372c.862.855 2.3.855 3.21 0 .864-.855.864-2.281 0-3.184l-4.36-4.324c-.384.618-.816 1.14-1.295 1.663-.623.618-1.294 1.093-1.965 1.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.394 18.579c-2.444 0-4.84-.95-6.614-2.709C.959 14.112 0 11.784 0 9.313c0-2.518.959-4.846 2.732-6.605 3.643-3.61 9.586-3.61 13.277 0 3.067 3.041 3.642 7.698 1.39 11.404-.384.665-.863 1.236-1.39 1.758-.575.57-1.294 1.093-2.013 1.52-1.438.809-3.02 1.189-4.602 1.189zm0-17.629c-2.157 0-4.313.808-5.943 2.424C1.821 4.989.959 7.08.959 9.314c0 2.232.862 4.323 2.444 5.891 2.636 2.614 6.806 3.184 10.065 1.378.671-.38 1.294-.855 1.822-1.378.48-.475.863-.998 1.246-1.568 2.013-3.279 1.486-7.507-1.246-10.216C13.708 1.758 11.55.951 9.394.951z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H22V22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindAProvider);
export default __webpack_public_path__ + "static/media/find-a-provider.541acb9ca63954a2025fd8c7028d7ae1.svg";
export { ForwardRef as ReactComponent };